<div class="no-chat-details-container">
  <div class="no-chat-details-content" *ngIf="!loading">
    <div class="no-chat-details-image-container">
      <img
        class="image-no-chat-details"
        src="../../../../../assets/images/chat-no-messages.svg"
      />
    </div>
    <div class="no-chat-details-text-container">
      <h2 class="text-no-chat-details-head">Olá, {{ userName }}</h2>
      <p class="text-no-chat-details-article">{{ text }}</p>
    </div>
  </div>
</div>
